<!-- Overlay -->
<div class="notification-overlay" *ngIf="show" [@fadeIn] (click)="close()"></div>

<!-- Modal -->
<div class="notification-modal" *ngIf="show" [@slideIn]>
  <div class="notification-content">

    <!-- Ícone -->
    <div class="notification-icon" [style.color]="getIconColor()">
      <i class="bi" [ngClass]="getIcon()"></i>
    </div>

    <!-- Título -->
    <h3 class="notification-title">{{ notification?.title }}</h3>

    <!-- Mensagem -->
    <p class="notification-message">{{ notification?.message }}</p>

    <!-- Botões -->
    <div class="notification-actions">
      <button
        *ngIf="notification?.cancelText"
        class="btn btn-secondary"
        (click)="cancel()">
        {{ notification?.cancelText }}
      </button>
      <button
        class="btn"
        [ngClass]="{
          'btn-success': notification?.type === 'success',
          'btn-danger': notification?.type === 'error',
          'btn-warning': notification?.type === 'warning',
          'btn-primary': notification?.type === 'info'
        }"
        (click)="confirm()">
        {{ notification?.confirmText || 'OK' }}
      </button>
    </div>

  </div>
</div>
